import { ApiEndpoints } from '../constantes/ApiEndpoints';
import { apiUserAccount } from '../../../utils/ApiService';
import {
  CreatePasswordRequest,
  CreatePasswordResponse,
  RecoveryPasswordRequest,
  RecoveryPasswordResponse
} from '../_types/password.types';
import { getSchemaIdFromStorage } from '../../../utils/getSchemaIdFromStorage';

// const schemaId = getSchemaIdFromStorage();

export const passwordService = {
  async createPassword(
    data: CreatePasswordRequest,
    accessToken: string
  ): Promise<CreatePasswordResponse> {
    const schemaId = getSchemaIdFromStorage();
    
    const response = await apiUserAccount.post<CreatePasswordResponse>(`${ApiEndpoints.account.createPassword}?schemaId=${schemaId}`, data,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          'X-Challenge-Verify': data?.captchaToken,
          'X-Challenge-Host': process.env.REACT_APP_TURNSTILE_HOST
        }
      }
    );
    
    return {...response, success: true};
  },
  
  async changePassword(
    params: RecoveryPasswordRequest,
    accessToken: string
  ): Promise<RecoveryPasswordResponse> {
    const schemaId = getSchemaIdFromStorage();
    const response = await apiUserAccount.post<RecoveryPasswordResponse>(
      `${ApiEndpoints.account.changePassword}?schemaId=${schemaId}`,
      params,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          'X-Challenge-Verify': params?.captchaToken,
          'X-Challenge-Host': process.env.REACT_APP_TURNSTILE_HOST
        }
      }
    );
    
    return response;
  },
  
  async recoveryPassword(
    params: RecoveryPasswordRequest,
    accessToken?: string
  ): Promise<RecoveryPasswordResponse> {
    const schemaId = getSchemaIdFromStorage();
    const response = await apiUserAccount.post<RecoveryPasswordResponse>(`${ApiEndpoints.account.recoveryResetPassword}?schemaId=${schemaId}`, params,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          'X-Challenge-Verify': params?.captchaToken,
          'X-Challenge-Host': process.env.REACT_APP_TURNSTILE_HOST
        }
      }
    );
    
    return response;
  }
};
